import type { GolfLeaderboardPlayerEntryFragment } from '../../__generated__/hooks'
import Avatar from './Avatar'
import Rank from './Rank'

const GolfRow = ({
  entry,
  isYou,
  isNet,
  onClick,
}: {
  entry: GolfLeaderboardPlayerEntryFragment
  isYou: boolean
  /** NET_STROKES ranking surfaces net strokes as the primary stat. */
  isNet: boolean
  /** Tap-the-row opens the detail sheet — whole row is the hit target. */
  onClick?: () => void
}) => (
  <li className="border-b border-ink-100 last:border-b-0">
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center gap-3 py-3 px-4 text-left active:bg-ink-100 transition-colors ${
        isYou ? 'bg-green-50' : ''
      }`}
    >
      <Rank rank={entry.rank} />
      <Avatar name={entry.player.name} size={32} />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-ink-900 truncate">
          {entry.player.name}
          {isYou ? (
            <span className="ml-2 text-xs font-bold text-green-700">· Du</span>
          ) : null}
        </div>
        <div className="text-[11px] text-ink-500 num">
          {entry.player.hcp != null ? `hcp ${entry.player.hcp} · ` : ''}
          {entry.holesRegistred}/18
        </div>
      </div>
      <div className="text-right shrink-0">
        {isNet ? (
          <>
            <div className="font-mono num font-bold text-ink-900">
              {entry.strokesNet || entry.strokes}
            </div>
            <div className="text-[10px] text-ink-500 num">
              {entry.points} pts
            </div>
          </>
        ) : (
          <>
            <div className="font-mono num font-bold text-ink-900">
              {entry.points}
            </div>
            <div className="text-[10px] text-ink-500 num">
              {entry.strokesNet || entry.strokes} slag
            </div>
          </>
        )}
      </div>
    </button>
  </li>
)

export default GolfRow
